// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"8071952e","211":"679ae55f","643":"898731ba","646":"c34fe8ac","648":"0c9371f4","748":"14c4d3c0","872":"f13ce756","910":"f862e886","969":"3a64cc74","972":"920bb671"}[chunkId] + ".chunk.css";
};